<template>
	<div class="p-grid">
		<div class="p-col-12">
			<div class="card">
        <Spinner v-if="isLoading"/>
        <div v-if="!isLoading && tenantData" :class="{'datatable-is-loading':tenantDataIsLoading}">
          <Toolbar class="p-mb-4 p-p-2 page-toolbar">
            <template #start>
              <div class="account-toolbar-title p-p-2">
                <span>
                  {{ $t('Account') }}: {{ tenantData.name }}
                </span>

                <div v-if="$store.getters.isTrialTenant && $store.getters.trialEndsAt" class="state-badge purple account-trial-badge">
                  {{ $t('billing.subscriptions.trialUntil', { date: formatUtcDay($store.getters.trialEndsAt) }) }}
                </div>
              </div>
            </template>
            <template #end>
              <div class="p-p-1">
                <Button :disabled="!$store.getters.isOwnerOrHigher || tenantDataIsLoading"
                        :loading="tenantDataIsLoading"
                        :label="$t('Edit')"
                        icon="ti-pencil"
                        @click="editItem"
                        class="p-button-success p-button-raised"/>
              </div>
            </template>
          </Toolbar>


          <div class="p-fieldset p-p-1 p-mt-3 p-mb-3">
            <div class="p-grid p-p-0 p-m-0">
              <div class="p-col-12 p-sm-12 p-md-12 p-lg-12" v-if="$store.state.mobileLayout || $store.state.tabletLayout">
                <table>
                  <tbody style="text-align: left">
                  <tr>
                    <th class="p-p-1">{{ $t('Email') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="tenantData.email">{{ tenantData.email }}</template>
                        <i v-else class="ti-minus"/>
                      </div>
                    </td>
                  </tr>
<!--                  <tr>-->
<!--                    <th class="p-p-1">{{ $t('Billing Email') }}:</th>-->
<!--                    <td class="p-p-1">-->
<!--                      <div class="p-ml-3">-->
<!--                        <template v-if="tenantData.billing_email">{{ tenantData.billing_email }}</template>-->
<!--                        <i v-else class="ti-minus"/>-->
<!--                      </div>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <th class="p-p-1">{{ $t('Country') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="tenantData.country_name">{{ tenantData.country_name }}</template>
                        <i v-else class="ti-minus"/>
                      </div>
                    </td>
                  </tr>
<!--                  <tr>-->
<!--                    <th class="p-p-1">{{ $t('Currency') }}:</th>-->
<!--                    <td class="p-p-1">-->
<!--                      <div class="p-ml-3">-->
<!--                        <template v-if="tenantData.currency">{{ tenantData.currency }}</template>-->
<!--                        <i v-else class="ti-minus"/>-->
<!--                      </div>-->
<!--                    </td>-->
<!--                  </tr>-->
                  <tr>
                    <th class="p-p-1">{{ $t('Short Name') }}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="tenantData.slug">{{ tenantData.slug }}</template>
                        <i v-else class="ti-minus"/>
                      </div>
                    </td>
                  </tr>
                  <tr>
                    <th class="p-p-1">{{$t('Created')}}:</th>
                    <td class="p-p-1">
                      <div class="p-ml-3">
                        <template v-if="tenantData.created_at">
                          {{ formatBy(tenantData.created_at, tenantData.creator) }}
                        </template>
                        <i v-else class="ti-minus"/>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <template v-else>
                <div class="p-col-12 p-sm-12 p-md-12 p-lg-6">
                  <table>
                    <tbody style="text-align: left">
                    <tr>
                      <th class="p-p-1">{{ $t('Email') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="tenantData.email">{{ tenantData.email }}</template>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
<!--                    <tr>-->
<!--                      <th class="p-p-1">{{ $t('Billing Email') }}:</th>-->
<!--                      <td class="p-p-1">-->
<!--                        <div class="p-ml-3">-->
<!--                          <template v-if="tenantData.billing_email">{{ tenantData.billing_email }}</template>-->
<!--                          <i v-else class="ti-minus"/>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                    </tr>-->
                    <tr>
                      <th class="p-p-1">{{ $t('Short Name') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="tenantData.slug">{{ tenantData.slug }}</template>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>

                    </tbody>
                  </table>
                </div>
                <div class="p-col-12 p-sm-12 p-md-12 p-lg-6">
                  <table>
                    <tbody style="text-align: left">
                    <tr>
                      <th class="p-p-1">{{ $t('Country') }}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="tenantData.country_name">{{ tenantData.country_name }}</template>
                          <i v-else class="ti-minus"/>
                        </div>
                      </td>
                    </tr>
<!--                    <tr>-->
<!--                      <th class="p-p-1">{{ $t('Currency') }}:</th>-->
<!--                      <td class="p-p-1">-->
<!--                        <div class="p-ml-3">-->
<!--                          <template v-if="tenantData.currency">{{ tenantData.currency }}</template>-->
<!--                          <i v-else class="ti-minus"/>-->
<!--                        </div>-->
<!--                      </td>-->
<!--                    </tr>-->
                    <tr>
                      <th class="p-p-1">{{$t('Created')}}:</th>
                      <td class="p-p-1">
                        <div class="p-ml-3">
                          <template v-if="tenantData.created_at">
                            {{ formatBy(tenantData.created_at, tenantData.creator) }}
                          </template>
                          <i v-else class="ti-minus"></i>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>
              </template>
            </div>
          </div>

          <TabMenu :model="tabMenuItems" class="p-p-1"/>
<!--          <router-view :tenant="tenantData"-->
          <router-view :tenantDataIsLoading="tenantDataIsLoading"
                       @update-items="updateItems"/>

          <AccountModal :visible="itemModal"
                        :item="item"
                        @update-items="updateItems"
                        @close="closeItemModal"/>
        </div>
        <div v-else-if="!isLoading && !tenantData" class="empty-page">{{ $t('No data available') }}</div>
			</div>

		</div>
	</div>
</template>

<script>
import httpClient from '@/services/http.services'
import settings from '@/settings.js'
import httpMixins from '@/mixins/httpMixins'
import showErrorsMixins from "@/mixins/showErrorsMixins";
import datatableMixins from "@/mixins/datatableMixins";
import formatMixins from "@/mixins/formatMixins";
import AccountModal from "@/pages/account/components/AccountModal";
import billingFeaturesMixins from '@/mixins/billingFeaturesMixins'

export default {
  components: { AccountModal },
  mixins: [ httpMixins, showErrorsMixins, datatableMixins, formatMixins, billingFeaturesMixins ],
	data() {
		return {
      tenantDataIsLoading: false,
      itemModal: false,
      item: {},
      isLoading: true,
      tenantData: null,
      tabMenuItems: [],
    }
	},
  watch: {
    '$i18n.locale'() {
      if (this.tenantData) {
        this.getTabMenu()
      }
    },
    '$store.state.firstLayerIsOpened'() {
      if (!this.$store.state.firstLayerIsOpened) {
        if (this.itemModal) {
          this.closeItemModal()
        }
      }
    },
    '$route.path'(path, oldPath) {
      if (
          path === '/account/billing-invoices'
          && path !== oldPath
      ) {
        this.getTenantData(false)
      }
    },
    billingEntitlementsReady() {
      if (this.tenantData) {
        this.getTabMenu()
      }
    },
  },
  mounted() {
    window.scrollTo(0, 0)
    if (settings.autoLogoutTimeout && this.$store.state.logoutTimestampIsOverdue) return false
    this.getPageData()
	},
  methods: {
    getPageData() {
      this.getTenantData()
    },
    // changeCustomerStatus(newStatus) {
    //   if (this.tenantData) {
    //     if (this.tenantData.customerStatus) {
    //       this.tenantData.customerStatus.status_id = newStatus
    //     } else {
    //       this.tenantData.customerStatus = {}
    //       this.tenantData.customerStatus.status_id = newStatus
    //     }
    //   }
    // },
    editItem() {
      if (this.tenantData) {
        this.item = this.tenantData
        this.itemModal = true
        this.$store.commit('toggleFirstLayer', true)
      }
    },
    updateItems() {
      this.getTenantData(false)
      // }
    },
    closeItemModal() {
      this.itemModal = false
      if (this.$store.state.firstLayerIsOpened === true ) {
        this.$store.commit('toggleFirstLayer', false)
      }
      this.item = {}
    },
    getTabMenu() {
      this.tabMenuItems = [
        {label: this.$t('Companies') + ` (${this.tenantData?.companies_count || 0})`, icon: 'ti-briefcase', to: `/account/companies`},
        {label: this.$t('Locations') + ` (${this.tenantData.locations_count || 0})`, icon: 'ti-location-pin', to: `/account/locations`},
        {label: this.$t('billing.subscriptions.subscriptionsLabel') + ` (${this.tenantData.subscriptions_count || 0})`, icon: 'ti-layers', to: `/account/subscriptions`},
        // {label: this.$t('Invoices') + ` (${this.tenantData.invoices_count || 0})`, icon: 'ti-receipt', to: `/account/billing-invoices`},
        {
          label: this.$t('Invoices')
              + (
                  this.tenantData.unpaid_invoices_count
                      ? ` (${this.tenantData.unpaid_invoices_count})`
                      : ''
              ),
          icon: 'ti-receipt',
          to: `/account/billing-invoices`
        },

        {label: this.$t('Email Accounts') + ` (${this.tenantData.email_accounts_count || 0})`, icon: 'ti-email', to: `/account/email-accounts`},
      ]
      if (this.canUseVisitSmsReminder || this.$store.getters.isSuperAdmin) {
        this.tabMenuItems.push({
          label: this.$t('SMS Sender Names')
              + ` (${this.tenantData.sms_sender_names_count || 0})`,
          icon: 'ti-mobile',
          to: '/account/sms-sender-names',
        })
      }
    },
    async getTenantData(showSpinner = true) {
      if (!this.userCanGetData || this.tenantDataIsLoading) return
      this.isLoading = showSpinner
      this.tenantDataIsLoading = true

      const ctrl = this.setController?.('tenantData')
      try {
        const { status, data } = await httpClient({
          url: 'account/get-data',
          method: 'post',
          params: {
          },
          signal: ctrl?.signal
        })

        if (status === 200 && data && data.success && data.item) {
          this.tenantData = data.item
          if (data.item.creator_first_name || data.item.creator_last_name) {
            this.tenantData.creator = {
              first_name: data.item.creator_first_name,
              last_name: data.item.creator_last_name,
              role: data.item.creator_role,
            }
          }
          this.getTabMenu()
        } else {
          this.showUnknownError()
          this.tenantData = null
        }
      } catch(err) {
        this.showError(err)
      } finally {
        this.tenantDataIsLoading = false
        this.isLoading = false
        if (ctrl && this._abortors?.tenantData === ctrl) {
          this._abortors.tenantData = null
        }
      }
    },
	},
}
</script>
<style scoped lang="scss">
.account-toolbar-title {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  font-size: 1.2em;
  color: inherit;
}

.account-trial-badge {
  margin-left: 12px;
  //background: var(--state-bg-purple);
  //color: var(--state-text-purple);
  font-size: 0.72em;
  //white-space: nowrap;
}

@media (max-width: 576px) {
  .account-trial-badge {
    margin-top: 6px;
    margin-left: 0;
    width: 100%;
  }
}
</style>